import { Injectable } from '@angular/core';
import { GuardResult, MaybeAsync, Router } from '@angular/router';
import { AuthenticationService } from '@flexyoo/auth';
import { EmployeeSettingsService } from '@flexyoo/employee/data-access';
import { map } from 'rxjs';
import { RoleEnum } from 'src/app/shared/models/general/general-enum';
import { appRoutesPerRoleDefaults } from '../../app-routes-per-role-defaults.constant';

@Injectable()
export class AdminGuard {
  constructor(
    protected router: Router,
    private auth: AuthenticationService,
    private readonly employeeSettingsService: EmployeeSettingsService
  ) {}

  canMatch(): MaybeAsync<GuardResult> {
    const user = this.auth.getCurrentUser();

    if (!user) {
      this.auth.logout();
      return false;
    }

    if (user.Role === RoleEnum.Admin) {
      return this.employeeSettingsService.updateAndLoadUserSettings(user.Id).pipe(
        map((userSettings) => {
          if (userSettings?.isActive || user.Impersonated) {
            return true;
          }

          this.auth.logout();
          return false;
        })
      );
    }

    if (user.Role === RoleEnum.Employee) {
      this.auth.navigateToEmployeeDefaultRoute();
      return false;
    }

    if ([RoleEnum.HR, RoleEnum.Opco].includes(user.Role as RoleEnum)) {
      return this.router.navigateByUrl(appRoutesPerRoleDefaults[user.Role]);
    }

    this.auth.logout();
    return false;
  }
}
